import React from 'react';
import isString from 'lodash-es/isString';

import { SafeHtml } from 'app/components/SafeHtml';

export const getTextWithoutEscape = (text: string | JSX.Element) => {
  return isString(text) ? <SafeHtml html={text} /> : text;
};
